//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbFacet from './rb-facet.vue'
export default {
  name: 'rb-color-facet',
  extends: RbFacet,
  computed: {
    tabindex() {
      return this.disabled ? -1 : 0
    },
    hasNoSpace() {
      const nRegex = new RegExp('^\\w+( +\\w+)*$', 'gi')
      return nRegex.test(this.label)
    },
  },
}
